import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/**
 * When the list has entries and the URL has no item id, open the first one.
 * Returns true during the render that precedes that redirect, so the detail
 * panel can stay in loading instead of flashing.
 * Used by Works / Beneficiaries / Titles list pages.
 */
const useSelectFirstRouteItem = <T extends { id: number }>(
    items: T[],
    selectedId: number | null,
    pathPrefix: string,
    onSelectFirst?: (id: number) => void,
) => {
    const navigate = useNavigate();
    const onSelectFirstRef = useRef(onSelectFirst);
    onSelectFirstRef.current = onSelectFirst;
    const isSelectingFirst = items.length > 0 && selectedId == null;

    useEffect(() => {
        if (!isSelectingFirst) return;
        const firstId = items[0].id;
        onSelectFirstRef.current?.(firstId);
        // Replace so Back does not land on the bare list URL and select the first item again.
        navigate(`${pathPrefix}/${firstId}`, { replace: true });
    }, [isSelectingFirst, items, navigate, pathPrefix]);

    return isSelectingFirst;
};

export default useSelectFirstRouteItem;
